import { useEffect, useState } from "react";
import { LabsService } from "../../../../Services/Labs.service";
import { Table, Dropdown, DropdownButton, Pagination } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import navdots from "../../../../Assets/images/navdots.svg";
import Toaster from "../../../../Components/Toaster";
import { Link } from "react-router-dom";
import SearchInput from "../../../../Components/AdministrativeSettings/SearchInput";
import AdminStatusDropdown from "../../../../Components/AdministrativeSettings/AdminStatusDropdown";
import TablePagination from "../../../../Components/AdministrativeSettings/TablePagination";
import LabTableRow from "../../../../Components/AdministrativeSettings/LabManagement/LabTableRow";
import Loader from "../../../../Components/Loader";
import { AdminService } from "../../../../Services/Admin.service";
import { useMediaQuery } from "react-responsive";
import LoadingComponent from "../../../../Components/LoadingComponent";
import NoListDataAvailable from "../../../../Components/NoListDataAvailable";

function LabHoursList(props) {
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('');

    const [totalLab, setLabTotal] = useState(0);
    const [labList, setLabList] = useState([]);
    const [selectedStatuses, setSelectedStatuses] = useState([]);
    const [statuses, setStatuses] = useState([]);

    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [pagination, setPagination] = useState({ page: 1, limit: 10, offset: 0 });

    const [searchName, setSearchName] = useState("");
    const [isSearchInputVisible, setSearchInputVisible] = useState(false);

    const [searchContactNumber, setSearchContactNumber] = useState("");
    const [isSearchContactNumberInputVisible, setSearchContactNumberInputVisible] = useState(false);

    const [loading, setLoading] = useState(false);

    const { isClearFilter } = props;
    const { onFilterCountChange } = props;

    useEffect(() => {
        if (isClearFilter) {
            setSelectedStatuses([]);
            setSearchName("");
            setSearchContactNumber("");
            setSearchInputVisible(false);
            onFilterCountChange(0);
        }
    }, [isClearFilter]);

    useEffect(() => {
        const count = [
            selectedStatuses.length > 0 ? 1 : 0,
            searchName ? 1 : 0,
            searchContactNumber ? 1 : 0,
        ].reduce((sum, val) => sum + val, 0);

        onFilterCountChange(count);
    }, [selectedStatuses, searchName, searchContactNumber]);

    useEffect(() => {
        fetchStatuses();
    }, []);


    useEffect(() => {
        fetchLabList();
    }, [pagination, selectedStatuses, searchName, searchContactNumber]);

    function fetchStatuses() {
        AdminService.getAdminListStatusTypes()
          .then((statusTypes) => {
            setStatuses(statusTypes);
    
          })
          .catch((error) => {
            console.error("Failed to fetch status types", error);
          });
    }

    const handleStatusChange = (status) => {
        if (selectedStatuses.includes(status)) {
          setSelectedStatuses(selectedStatuses.filter((s) => s !== status));
        } else {
          setSelectedStatuses([...selectedStatuses, status]);
        }
        setPagination({ ...pagination, page: 1, offset: 0 });
    };
      
    function fetchLabList() {
        const filters = {
            name: searchName,
            contact_number: searchContactNumber,
            status: selectedStatuses,
        };

        const params = {
            limit: pagination.limit,
            offset: pagination.offset,
            filters: [filters],
        };

        setLoading(true);
        LabsService.getLabs(params)
        .then((response) => {              
            setLabList(response.data.list);
            setLabTotal(response.data.total);
            setLoading(false);
        })
        .catch((error) => {
            setToastMessage(error.message || 'Something went wrong.');
            setShowToast(true);
            setToastVariant('error');
            setLoading(false);
        });
    }

    const handleRowsPerPageChange = (newRowsPerPage) => {
        if (newRowsPerPage === 'Show All') {
            setRowsPerPage(totalLab);
            setPagination({ limit: totalLab, offset: 0, page: 1 });
        } else {
            setRowsPerPage(Number(newRowsPerPage));
            setPagination({ limit: Number(newRowsPerPage), offset: 0, page: 1 });
        }
    };

    const totalFiltered = labList.length;  //ex 10 
    const totalPages = Math.ceil(totalLab / rowsPerPage); // 10 / 2rpp  then  5 pages

    const handleNextPage = () => {
        setPagination({ ...pagination, offset: pagination.page * rowsPerPage, page: pagination.page + 1 });
    };

    const handlePreviousPage = () => {
        setPagination({ ...pagination, offset: (pagination.page - 2) * rowsPerPage, page: pagination.page - 1 });
    };

    const handleDeleteUser = async (labId) => {
        try {
          
          setLoading(true);
          const response = await LabsService.deleteLab(labId);
    
          if (response.success == true) {
            setToastMessage(response.message);
            setToastVariant('success');
            fetchLabList();
          }
          else {
            setToastMessage(response.message);
            setToastVariant('error');
          }
        } catch (error) {
            setToastMessage(error.message || 'Something went wrong.');
            setToastVariant('error');
        } finally {
            setLoading(false);
            setShowToast(true);
        }
    };
    const handleChangeStatus = async (lab, status) => {
        setLoading(true);
        const newStatus = lab.active ? 0 : 1; // Determine the new status
        try {
            const response = await LabsService.changeLabStatus(lab.id, newStatus); // Pass the user ID and new status

            if (response.success == true) {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('success');
                fetchLabList();
                setLoading(false); 
            }
            else {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('error');
                setLoading(false);

            }
        } catch (error) {
            setToastMessage("Failed to change lab status");
            setShowToast(true);
            setToastVariant('error');
            console.error("Failed to change lab status:", error);
            setLoading(false); 
        }
    };

    const isMobile = useMediaQuery({ maxWidth: 768 });
    return (
        <>
        <Loader loading={loading} />
        <div>
        {isMobile ? (
           <div className="admin-card-list mt-3">
            {labList.length > 0 ? (
              <div  className="row"> 
              {
                labList.map((lab, index) => (
              <div className="col-sm-12 col-md-6 mb-3" key={index}>
                <LabTableRow
                    key={index}
                    lab={lab}
                    handleDeleteUser={handleDeleteUser} 
                    handleChangeStatus={handleChangeStatus}
                />
              </div>
            ))} 
            </div>) : (<NoListDataAvailable type="labs" />)}
         </div>
         ):(<>
            <div className="el-table-container el-board-table">
                <Table hover >
                    <thead>
                        <tr>
                            <th style={{ width: '20%' }}>
                                <div className="el-table-input">
                                    <SearchInput
                                        label="Lab"
                                        value={searchName}
                                        setValue={setSearchName}
                                        isVisible={isSearchInputVisible}
                                        setVisible={setSearchInputVisible}
                                    />
                                </div>
                            </th>
                            <th style={{ width: '20%' }}>
                                <div className="el-table-input">
                                    <label>Address</label>
                                </div>
                            </th>
                            <th style={{ width: '20%' }}>
                                <div className="el-table-input">
                                    <label>City</label>
                                </div>
                            </th>
                            <th>
                                <AdminStatusDropdown
                                    statuses={statuses}
                                    selectedStatuses={selectedStatuses}
                                    handleStatusChange={handleStatusChange}
                                    setSelectedStatuses={setSelectedStatuses}
                                    label = "Status"
                                />
                            </th>
                            <th style={{ width: '20%' }}>
                                <div className="el-table-input">
                                    <SearchInput
                                        label="Contact Number"
                                        value={searchContactNumber}
                                        setValue={setSearchContactNumber}
                                        isVisible={isSearchContactNumberInputVisible}
                                        setVisible={setSearchContactNumberInputVisible}
                                    />
                                </div>
                            </th>
                            {/* <th style={{ width: '20%' }}>
                                <div className="el-table-input">
                                    <label>Country</label>
                                </div>
                            </th>                                                  */}
                            <th style={{ width: '20%' }}>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Array.isArray(labList) && labList.length > 0 ? (
                            labList.map((lab, index) => (
                                <LabTableRow
                                    key={index}
                                    lab={lab}
                                    handleDeleteUser={handleDeleteUser} 
                                    handleChangeStatus={handleChangeStatus}
                                />
                            ))
                        ) : ( <NoListDataAvailable type="labs" /> )}
                    </tbody>
                </Table>
            </div>
            </>
         )}
            <TablePagination
                rowsPerPage={rowsPerPage}
                handleRowsPerPageChange={handleRowsPerPageChange}
                pagination={pagination}
                totalPages={totalPages}
                handlePreviousPage={handlePreviousPage}
                handleNextPage={handleNextPage}
            />
            <Toaster
                show={showToast}
                message={toastMessage}
                variant={toastVariant}
                onClose={() => setShowToast(false)}
            />
        </div>
        </>
    );

}

export default LabHoursList;